import axios from "axios";
import { useEffect, useState } from "react";

export const useTablero = (programa = "PR", proceso = 1, nivel = 0, icveie = 0) => {

    let resumenes = `${process.env.REACT_APP_PROD}/api/${programa}/Resumen/${proceso}/${nivel}`;
    let estados = `${process.env.REACT_APP_PROD}/api/${programa}/Estados/${proceso}/${nivel}`;
    let czs = `${process.env.REACT_APP_PROD}/api/${programa}/CZs/${proceso}/${nivel}/1`;
    
    if(icveie !== 0)
    {
        resumenes = `${process.env.REACT_APP_PROD}/api/${programa}/Resumen/${proceso}/${nivel}/${icveie}`;
        czs = `${process.env.REACT_APP_PROD}/api/${programa}/CZs/${proceso}/${nivel}/${icveie}`;
    }

    const [tablero, setTablero] = useState({
        loading: true,
        icveie: 0,
        info: []
    });
    
    useEffect(() => {

        setTablero({
            loading: true,
            icveie: 0,
            info: []
        });

        let resumenes_req = axios.get(resumenes);
        let estados_req = axios.get(estados);
        let czs_req = axios.get(czs);
    
        axios.all([resumenes_req, estados_req, czs_req])
            .then(axios.spread((...responses) => {

                setTablero({
                    loading: false,
                    icveie: icveie,
                    info: [responses[0].data, responses[1].data, responses[2].data]
                })

            })
        )

    }, [programa, resumenes, estados, czs, icveie])


    return tablero;

}
